import { render, staticRenderFns } from "./CriteriaRadioGroup.vue?vue&type=template&id=c2b29cc0&scoped=true&"
import script from "./CriteriaRadioGroup.vue?vue&type=script&lang=js&"
export * from "./CriteriaRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaRadioGroup.vue?vue&type=style&index=0&id=c2b29cc0&lang=scss&scoped=true&"
import style1 from "./CriteriaRadioGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b29cc0",
  null
  
)

export default component.exports